import { useCallback, useContext } from 'react';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import { ChannelLabel } from '../../../capability-editor/public/components';
import { ChannelCapabilitiesConfigContext } from 'conversations-thread-view/channel-capabilities/context/ChannelCapabilitiesConfigContext';
import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { usePopOutEditorState } from '../../../pop-out/public/hooks';
import { useShepherdDismissState } from '../hooks/useShepherdDismissState';
import styled from 'foundations-theming/utils';
import { DialogButton } from 'foundations-components/transitional/components/DialogButton';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { EnlargeIcon, ExitFullScreenIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ATTRIBUTE_STORAGE_KEY = `floating-composer-fullscreen-shepherd`;
const Wrapper = styled.div.withConfig({
  displayName: "FloatingComposeEditorWrapper__Wrapper",
  componentId: "uy3mm1-0"
})(["display:flex;flex-direction:column;flex-grow:1;background:", ";box-shadow:rgb(0 0 0 / 35%) 0 1px 24px 0;position:relative;border-radius:3px 3px 0 0;width:100%;.floating-editor-header{border-radius:3px 3px 0 0;}.floating-editor-header > div{border-radius:3px 3px 0 0;padding-left:", ";min-height:0;height:50px;align-items:center;background-color:", " !important;font-size:1rem;}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.space[600], ({
  theme
}) => theme.color['fill-accent-neutral-hover']);
const GatedChannelLabel = () => {
  const {
    genericChannelId
  } = useContext(ChannelCapabilitiesConfigContext);
  return /*#__PURE__*/_jsx(Text, {
    as: "h2",
    color: "text-core-on-fill-default",
    children: /*#__PURE__*/_jsx(ChannelLabel, {
      genericChannelId: genericChannelId
    })
  });
};
GatedChannelLabel.displayName = 'GatedChannelLabel';
export const FloatingComposeEditorWrapper = ({
  children
}) => {
  const {
    close
  } = useFloatingEditorState();
  const {
    isOpen: isExpanded,
    open: expand,
    close: collapse
  } = usePopOutEditorState('floating');
  const {
    isDismissed,
    setDismissed
  } = useShepherdDismissState({
    attributeKey: ATTRIBUTE_STORAGE_KEY
  });
  const expandAndDismissShepherd = useCallback(() => {
    expand();
    if (!isDismissed) setDismissed();
  }, [expand, setDismissed, isDismissed]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    "data-selenium-test": "popout-composer-editor",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "floating-editor-header",
      children: [/*#__PURE__*/_jsx(GatedChannelLabel, {}), /*#__PURE__*/_jsx(DialogButton, {
        "aria-label": "expand",
        icon: isExpanded ? ExitFullScreenIcon : EnlargeIcon,
        marginInlineEnd: "200",
        inlineSize: "13px",
        onClick: isExpanded ? collapse : expandAndDismissShepherd,
        "data-selenium-test": "expand-popout-composer",
        "data-test-id": "floating-composer-expand-button"
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        insetBlockStart: "16px",
        inlineSize: "13px",
        onClick: close,
        "data-selenium-test": "close-popout-composer"
      })]
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorBoundaryName: "FloatingComposeEditor",
      errorLoggingTitle: "Inbox Floating Compose Editor",
      children: children
    }, "composer-ui")]
  });
};
FloatingComposeEditorWrapper.displayName = 'FloatingComposeEditorWrapper';